import React, { Component } from 'react';
import PropTypes from 'prop-types';

class IndustrySector extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            expanded: false
        }
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var that = this;
        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return(
            <div>
            {this.props.name &&
                <div>
                    <h2 className="group-title" onClick={ this.toggle }>
                        {this.props.name} (<span className='results-count'>{ this.props.data.length }</span>)
                        <span className={toggleClasses}/>
                    </h2>
                    <div className={ this.state.expanded ? 'group-body indent-body expanded' : 'group-body indent-body' }>
                        {this.props.data.map(function(sector, idx) {

                            let sentimentClassName;
                            if (sector.sentiment) {
                                if (sector.sentiment.class === 'positive') {
                                    sentimentClassName = 'mention-sentiment-positive';
                                } else if (sector.sentiment.class === 'neutral') {
                                    sentimentClassName = 'mention-sentiment-neutral';
                                } else if (sector.sentiment.class === 'negative') {
                                    sentimentClassName = 'mention-sentiment-negative';
                                }
                            }

                            return <div key={idx}>
                                <div>{sector[that.props.name]} ({sector.salience})</div>
                                {sector.sentiment &&
                                    <div className={ 'mention-sentiment-wrapper ' + sentimentClassName}>
                                        {(sector.sentiment.sentimentScore !== undefined) &&
                                            <div><span className="fa fa-angle-double-right"/> Score : {sector.sentiment.sentimentScore}</div>
                                        }
                                        {(sector.sentiment.score !== undefined) &&
                                            <div><span className="fa fa-angle-double-right"/> Score : {sector.sentiment.score}</div>
                                        }
                                        <div><span className="fa fa-angle-double-right"/> Class : {sector.sentiment.class}</div>
                                        {('classConfidence' in sector.sentiment) &&
                                            <div><span className="fa fa-angle-double-right"/> Confidence : {sector.sentiment.classConfidence}</div>
                                        }
                                        {('topic' in sector.sentiment) &&
                                            <div><span className="fa fa-angle-double-right"/> Topic : {sector.sentiment.topic}</div>
                                        }
                                    </div>
                                }
                            </div>
                        })}
                    </div>
                </div>
            }
            </div>
        );
    }
};

IndustrySector.propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired
};

class Industries extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            expanded: false
        }
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var that = this;
        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return(
            <div>
            {this.props.industries &&
                <div>
                    <h2 className="group-title" onClick={ this.toggle }>
                        industry
                        <span className={toggleClasses}/>
                    </h2>

                    <div className={ this.state.expanded ? 'group-body expanded' : 'group-body' }>
                        {'businessSectors' in this.props.industries &&
                            <IndustrySector name="businessSector" data={this.props.industries.businessSectors}/>
                        }
                        {'economicSectors' in this.props.industries &&
                            <IndustrySector name="economicSector" data={this.props.industries.economicSectors}/>
                        }
                        {'industryGroups' in this.props.industries &&
                            <IndustrySector name="industryGroup" data={this.props.industries.industryGroups}/>
                        }
                    </div>
                </div>
            }
            </div>
        );
    }
};

Industries.propTypes = {
    industries: PropTypes.object
};

export default Industries;

